function formatDuration(durationInSeconds, minuteBreakpoint = 60) {
    if (Number.isInteger(durationInSeconds)) {
        if (durationInSeconds > 24 * 60 * 60) return ''; // Show format from server

        if (durationInSeconds > 60 * 60)
            return `${Math.floor(
                durationInSeconds / 60 / 60
            )} tim  ${Math.floor((durationInSeconds / 60) % 60)} min`;

        if (durationInSeconds > minuteBreakpoint)
            return `${Math.floor(durationInSeconds / 60)} min`;

        return `${durationInSeconds} s`;
    } else {
        return '';
    }
}

function formatNumberWithSeparators(number, separator = '\u2006') {
    return number
        .toString()
        .replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1' + separator);
}

// https://developer.mozilla.org/en/docs/Web/JavaScript/Reference/Global_Objects/Number/toLocaleString
function toLocaleStringSupportsLocales() {
    try {
        Number(0).toLocaleString('i');
    } catch (e) {
        return e.name === 'RangeError';
    }
    return false;
}

// https://developer.mozilla.org/en/docs/Web/JavaScript/Reference/Global_Objects/Number/toLocaleString
function toLocaleStringSupportsOptions() {
    return !!(
        typeof Intl === 'object' &&
        Intl &&
        typeof Intl.NumberFormat === 'function'
    );
}

const isLocaleFormattingSupportedInBrowser =
    toLocaleStringSupportsLocales() && toLocaleStringSupportsOptions();

function formatPrice(price, locale = 'sv-SE', options = {}) {
    if (!isLocaleFormattingSupportedInBrowser) {
        return `${typeof price === 'number' ? price : parseInt(price)} ${
            locale.startsWith('sv') ? 'kr' : 'SEK'
        }`;
    }
    let formattedPrice = typeof price !== 'number' ? parseInt(price) : price;
    const opts = {
        style: 'currency',
        currency: 'SEK',
        currencyDisplay: 'symbol',
        useGrouping: false,
        minimumFractionDigits: 0,
        maximumFractionDigits: 2,
        ...options
    };
    formattedPrice = formattedPrice.toLocaleString(locale, opts);
    formattedPrice = formatNumberWithSeparators(formattedPrice);
    return formattedPrice;
}

function formatDateWithDayOfWeek(dateString, locale) {
    if (!isLocaleFormattingSupportedInBrowser) {
        return dateString;
    }

    var options = {
        weekday: 'long',
        year: undefined,
        month: 'long',
        day: 'numeric'
    };
    return new Intl.DateTimeFormat(locale, options).format(
        Date.parse(dateString)
    );
}

export {
    formatDuration,
    formatNumberWithSeparators,
    formatPrice,
    formatDateWithDayOfWeek
};
